import React from 'react'

function PenaltyTab(): React.ReactElement {
  return <div>...</div>
}

export default PenaltyTab
